<template>
  <div>
    <Menu />
    <div class="container main">
      <div class="row">
        <div class="col-md-12">
          <SectionTitle
            title="BPA C"
            description="Procedimentos Ambulatoriais Consolidados"
            url="/bpa-e-ras"
            :enabledModalInformacao="false"
            :textModalInformacao="text"
          />
        </div>
      </div>
      <router-view></router-view>
    </div>
    <Footer />
  </div>
</template>

<script>
import Menu from '@/components/Menu'
import Footer from '@/components/Footer'
import SectionTitle from '@/components/SectionTitle'
import { infoHtml } from './utils.js'

export default {
  components: {
    Menu,
    Footer,
    SectionTitle,
  },
  metaInfo: {
    title: 'BPA C',
    titleTemplate: null,
  },
  data() {
    return {
      text: infoHtml,
    }
  },
}
</script>

<style></style>
